import { APICore } from './apiCore'

const api = new APICore()

function updateQRConf (params) {
  const baseUrl = '/qr-conf'
  return api.updateWithFile(baseUrl, params)
}

function generateQR (params) {
  const baseUrl = '/qr-conf/generate'
  return api.create(baseUrl, params)
}

export { updateQRConf, generateQR }
